// extracted by mini-css-extract-plugin
module.exports = {"SliderSet":"styles_SliderSet__vbn7V","toolbar":"styles_toolbar__3SiEE","text":"styles_text__2ouYX","slider_container":"styles_slider_container__L-oNu"};